export const BUS_KEYCLOAK_ATTRIBUTE = "b2b-api-business-unit";
export const BUS_SESSION_STORAGE_KEY = "bus";
export const SELECTED_BUS_SESSION_STORAGE_KEY = "selected_bus";
